// import React, { useState } from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { TbLayoutDashboardFilled } from "react-icons/tb";
// import { RiShoppingBag3Fill } from "react-icons/ri";
// import { FaChartLine } from "react-icons/fa";
// import { MdOutlineReportProblem, MdOutlineWhereToVote } from "react-icons/md";
// import { IoIosLogOut } from "react-icons/io";
// import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
// import { LuClipboardCheck } from "react-icons/lu";
// import { BsCheck2Circle, BsLightningCharge } from "react-icons/bs";
// import { AiOutlineDropbox } from "react-icons/ai";
// import { IoCard } from "react-icons/io5";
// import { AiOutlineFolderView } from "react-icons/ai";
// import { TbFlag3 } from "react-icons/tb";
// import { FaRegHandshake } from "react-icons/fa";
// import { MdLocalOffer } from "react-icons/md";
// import { MdOutlineBrandingWatermark } from "react-icons/md";
// import { MdOutlineLibraryAdd } from "react-icons/md";
// import { GoSponsorTiers } from "react-icons/go";
// import { MdOutlineLocalOffer } from "react-icons/md";
// import { CiBank } from "react-icons/ci";
// const menuItems = [
//   {
//     label: "Dashboard",
//     path: "/seller/dashboard",
//     icon: <TbLayoutDashboardFilled />,
//   },
//   {
//     label: "Products",
//     icon: <RiShoppingBag3Fill />,
//     submenu: [
//       {
//         label: "Add Product",
//         path: "/seller/products/add_product",
//         icon: <LuClipboardCheck />,
//       },
//       {
//         label: "View Products",
//         path: "/seller/products/view_products",
//         icon: <LuClipboardCheck />,
//       },
//     ],
//   },
//   {
//     label: "Stocks",
//     path: "/seller/stocks",
//     icon: <AiOutlineDropbox />,
//   },
//   {
//     label: "Orders",
//     icon: <IoCard />,
//     submenu: [
//       {
//         label: "Orders View",
//         path: "/seller/orders/view_orders",
//         icon: <AiOutlineFolderView />,
//       },
//     ],
//   },
//   {
//      label: "Sales",
//     // path: "/seller/sales",
//     icon: <FaChartLine />,
//     submenu: [
//       {
//         label: "Sales Overview",
//         path: "/seller/sales/overview",
//         icon: <FaChartLine />,
//       },
//       {
//         label: "Sales Report",
//         path: "/seller/sales/sales_report",
//         icon: <TbFlag3 />,
//       },
//       {
//         label: "Sales View",
//         path: "/seller/sales/view_sales",
//         icon: <FaRegHandshake />,
//       },
//     ],
//   },
//   {
//     label: "Offer & Brand",
//     icon: <MdLocalOffer />,
//     submenu: [
//       {
//         label: "Brand",
//         path: "/seller/offer_brand/brand",
//         icon: <MdOutlineBrandingWatermark />,
//       },
//       {
//         label: "Banner",
//         path: "/seller/offer_brand/banner",
//         icon: <MdOutlineLibraryAdd />,
//       },
//       {
//         label: "Sponsored",
//         path: "/seller/offer_brand/sponsored",
//         icon: <GoSponsorTiers />,
//       },
//       {
//         label: "Offer",
//         path: "/seller/offer_brand/Offer",
//         icon: <MdOutlineLocalOffer />,
//       },
//     ],
//   },
//   {
//     label: "Charges",
//     icon: <BsLightningCharge />,
//     path: "/seller/charges",
//   },
//   {
//     label: "Statements",
//     icon: <CiBank />,
//     path: "/seller/statements",
//   },
// ];

// const SellerSidebar = () => {
//   const location = useLocation(); // Get the current URL
//   const [dropdownStates, setDropdownStates] = useState({});

//   // Toggle dropdown state
//   const toggleDropdown = (key) => {
//     setDropdownStates((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   // Function to check if the main menu item or any of its submenu items is active
//   const isActive = (item) => {
//     if (item.submenu) {
//       return item.submenu.some((subItem) =>
//         location.pathname.startsWith(subItem.path),
//       );
//     }
//     return location.pathname.startsWith(item.path);
//   };

//   return (
//     <div className="relative flex h-full flex-col">
//       {/* Sidebar Header */}
//       <div className="flex w-full flex-grow flex-col items-start overflow-x-auto">
//         <div className="my-6 flex w-full items-center justify-center">
//           <img src="/images/logo/navlogo.png" alt="Logo" className="w-5/6" />
//         </div>
//         {/* Navigation Menu */}
//         <ul className="w-full space-y-4 text-[15px] font-semibold">
//           {menuItems.map((item, index) => (
//             <li key={index} className="flex w-full flex-col">
//               {/* Render Main Item */}
//               <NavLink to={item.path || "#"}>
//                 <div
//                   className={`flex w-full cursor-pointer items-center justify-between p-2 transition-all duration-300 ${
//                     isActive(item)
//                       ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC] text-brand-primary"
//                       : "text-gray-700 hover:bg-[#CDF2CC] hover:text-brand-primary"
//                   }`}
//                   onClick={() => item.submenu && toggleDropdown(index)}
//                 >
//                   <div className="flex items-center space-x-2">
//                     {item.icon}
//                     <span>{item.label}</span>
//                   </div>
//                   {item.submenu &&
//                     (dropdownStates[index] ? (
//                       <AiFillCaretUp />
//                     ) : (
//                       <AiFillCaretDown />
//                     ))}
//                 </div>
//               </NavLink>

//               {/* Render Submenu if Open */}
//               {item.submenu && dropdownStates[index] && (
//                 <ul className="space-y-2 transition duration-500 ease-in-out">
//                   {item.submenu.map((subItem, subIndex) => (
//                     <li key={subIndex}>
//                       <NavLink
//                         to={subItem.path}
//                         className={({ isActive }) =>
//                           `flex items-center space-x-2 py-2 pl-6 transition-all duration-300 hover:text-brand-primary ${
//                             isActive
//                               ? "border-l-8 border-solid border-brand-primary text-brand-primary"
//                               : "text-gray-700 hover:bg-[#CDF2CC] hover:text-brand-primary"
//                           }`
//                         }
//                       >
//                         {subItem.icon}
//                         <span>{subItem.label}</span>
//                       </NavLink>
//                     </li>
//                   ))}
//                 </ul>
//               )}
//             </li>
//           ))}
//         </ul>
//       </div>

//       {/* Logout Section */}
//       <div className="mt-auto p-4">
//         <NavLink
//           to="/logout"
//           className="flex w-full items-center space-x-2 font-semibold text-brand-text-light hover:text-red-700"
//         >
//           <IoIosLogOut className="text-xl" />
//           <span>Logout</span>
//         </NavLink>
//       </div>
//     </div>
//   );
// };

// export default SellerSidebar;

// code for route change

import React, { useState, useMemo, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { RiShoppingBag3Fill } from "react-icons/ri";
import { FaChartLine } from "react-icons/fa";
import { MdOutlineReportProblem, MdOutlineWhereToVote } from "react-icons/md";
import { IoIosLogOut } from "react-icons/io";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { LuClipboardCheck } from "react-icons/lu";
import { BsCheck2Circle, BsLightningCharge } from "react-icons/bs";
import { AiOutlineDropbox } from "react-icons/ai";
import { IoCard } from "react-icons/io5";
import { AiOutlineFolderView } from "react-icons/ai";
import { TbFlag3 } from "react-icons/tb";
import { FaRegHandshake } from "react-icons/fa";
import { MdLocalOffer } from "react-icons/md";
import { MdOutlineBrandingWatermark } from "react-icons/md";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { GoSponsorTiers } from "react-icons/go";
import { MdOutlineLocalOffer } from "react-icons/md";
import { CiBank } from "react-icons/ci";
import { MdOutlinePointOfSale, MdHistory } from "react-icons/md";
import { useAuth } from "../../../context/AuthContext";
const menuItems = [
  {
    label: "Dashboard",
    path: "/seller",
    icon: <TbLayoutDashboardFilled />,
  },
  {
    label: "Products",
    icon: <RiShoppingBag3Fill />,
    submenu: [
      {
        label: "Add Product",
        path: "/seller/products/add_product",
        icon: <LuClipboardCheck />,
      },
      {
        label: "View Products",
        path: "/seller/products/view_products",
        icon: <LuClipboardCheck />,
      },
    ],
  },
  {
    label: "Stocks",
    path: "/seller/stocks",
    icon: <AiOutlineDropbox />,
  },
  {
    label: "Orders",
    icon: <IoCard />,
    submenu: [
      {
        label: "Orders View",
        path: "/seller/orders/view_orders",
        icon: <AiOutlineFolderView />,
      },
    ],
  },
  {
    label: "Sales",
    // path: "/seller/sales",
    icon: <FaChartLine />,
    submenu: [
      {
        label: "Sales Overview",
        path: "/seller/sales/overview",
        icon: <FaChartLine />,
      },
      {
        label: "Sales Report",
        path: "/seller/sales/sales_report",
        icon: <TbFlag3 />,
      },
      {
        label: "Sales View",
        path: "/seller/sales/view_sales",
        icon: <FaRegHandshake />,
      },
    ],
  },
  {
    label: "Offer & Brand",
    icon: <MdLocalOffer />,
    submenu: [
      {
        label: "Brand",
        path: "/seller/offer/brand",
        icon: <MdOutlineBrandingWatermark />,
      },
      {
        label: "Banner",
        path: "/seller/offer/banner",
        icon: <MdOutlineLibraryAdd />,
      },
      {
        label: "Sponsored",
        path: "/seller/offer_brand/sponsored",
        icon: <GoSponsorTiers />,
      },
      {
        label: "Offer",
        path: "/seller/offer_brand/Offer",
        icon: <MdOutlineLocalOffer />,
      },
    ],
  },
  {
    label: "Revenue",
    icon: <MdOutlinePointOfSale />,
    submenu: [
      {
        label: "Revenue Dashboard",
        path: "/seller/revenue",
        icon: <TbLayoutDashboardFilled />,
        exact: true
      },
      {
        label: "Transaction History",
        path: "/seller/revenue/transactions",
        icon: <MdHistory />,
      },
    ],
  },
  {
    label: "Charges",
    icon: <BsLightningCharge />,
    path: "/seller/charges",
  },
  {
    label: "Statements",
    icon: <CiBank />,
    path: "/seller/statements",
  },
];

// Updated active check that respects the 'exact' property
const checkItemActive = (item, currentPath) => {
  if (item.path) {
    if (item.exact) {
      if (currentPath === item.path) {
        return true;
      }
    } else {
      if (currentPath.startsWith(item.path)) {
        return true;
      }
    }
  }
  if (item.submenu) {
    return item.submenu.some((subItem) => checkItemActive(subItem, currentPath));
  }
  return false;
};

// Recursive function to get all active paths for a given location
const getActivePaths = (items, currentPath, parentPath = "") => {
  let activePaths = [];

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const currentKeyPath = parentPath ? `${parentPath}-${i}` : `${i}`;

    if (item.path) {
      // Use exact match if 'exact' flag is present; otherwise, startsWith check.
      if (item.exact && currentPath === item.path) {
        activePaths.push(currentKeyPath);
      } else if (!item.exact && currentPath.startsWith(item.path)) {
        activePaths.push(currentKeyPath);
      }
    }

    if (item.submenu && item.submenu.length > 0) {
      const subActivePaths = getActivePaths(item.submenu, currentPath, currentKeyPath);
      if (subActivePaths.length > 0) {
        activePaths.push(currentKeyPath);
        activePaths = [...activePaths, ...subActivePaths];
      }
    }
  }

  return activePaths;
};

const MenuItem = ({ item, keyPath, depth, toggleDropdown, dropdownStates, location }) => {
  const hasSubmenu = item.submenu && item.submenu.length > 0;
  const isOpen = dropdownStates[keyPath] || false;

  const isActive = useMemo(() => checkItemActive(item, location.pathname), [item, location.pathname]);

  const handleClick = (e) => {
    if (hasSubmenu) {
      e.preventDefault();
      toggleDropdown(keyPath);
    }
  };

  return (
    <li className="flex w-full flex-col">
      <NavLink
        to={hasSubmenu ? "/" : item.path || "/"}
        onClick={handleClick}
        className={({ isActive: isNavActive }) =>
          `flex items-center transition-all duration-300 ${isActive || isNavActive ? "" : "text-gray-700 hover:text-brand-primary"
          }`
        }
      >
        <div
          className={`flex w-full cursor-pointer items-center justify-between transition-all duration-300 my-[2px] ${isActive
            ? "border-l-8 border-solid border-brand-primary bg-[#CDF2CC]"
            : "hover:bg-[#CDF2CC]"
            }`}
          style={{
            padding: "0.5rem",
            paddingLeft: depth === 0 ? "0.5rem" : `${depth * 1.5}rem`,
          }}
        >
          <div className="flex items-center space-x-2">
            {item.icon}
            <span>{item.label}</span>
          </div>
          {hasSubmenu && (isOpen ? <AiFillCaretUp /> : <AiFillCaretDown />)}
        </div>
      </NavLink>

      {hasSubmenu && isOpen && (
        <ul className="space-y-2 transition duration-500 ease-in-out">
          {item.submenu.map((subItem, subIndex) => (
            <MenuItem
              key={subIndex}
              item={subItem}
              keyPath={`${keyPath}-${subIndex}`}
              depth={depth + 1}
              toggleDropdown={toggleDropdown}
              dropdownStates={dropdownStates}
              location={location}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

const SellerSidebar = () => {
  const location = useLocation();
  const [dropdownStates, setDropdownStates] = useState({});
  const { logout } = useAuth();

  // Initialize dropdown states based on current path
  useEffect(() => {
    const activePaths = getActivePaths(menuItems, location.pathname);
    const newDropdownStates = {};

    // Set active paths to open
    activePaths.forEach((path) => {
      newDropdownStates[path] = true;
    });

    setDropdownStates(newDropdownStates);
  }, [location.pathname]);

  const toggleDropdown = (keyPath) => {
    setDropdownStates((prev) => {
      const newState = { ...prev };
      const pathSegments = keyPath.split("-");

      // If closing a submenu, close all its children
      if (newState[keyPath]) {
        Object.keys(newState).forEach((key) => {
          if (key.startsWith(keyPath + "-")) {
            newState[key] = false;
          }
        });
      } else {
        // If opening a submenu, close siblings at the same level
        if (pathSegments.length > 1) {
          const parentPath = pathSegments.slice(0, -1).join("-");
          Object.keys(newState).forEach((key) => {
            if (key.startsWith(parentPath + "-") && key !== keyPath && !key.startsWith(keyPath + "-")) {
              newState[key] = false;
            }
          });
        } else {
          Object.keys(newState).forEach((key) => {
            if (key.indexOf("-") === -1 && key !== keyPath) {
              newState[key] = false;
            }
          });
        }
      }
      // Toggle the current item
      newState[keyPath] = !newState[keyPath];
      return newState;
    });
  };

  return (
    <div className="relative flex h-full flex-col border-r border-gray-200 bg-white">
      <div className="my-6 flex w-full items-center justify-center">
        <img src="/images/logo/navlogo.png" alt="Logo" className="w-5/6" />
      </div>
      <div className="flex w-full flex-grow flex-col items-start overflow-x-auto">
        <ul className="w-full space-y-4 text-[15px] font-semibold">
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              item={item}
              keyPath={`${index}`}
              depth={0}
              toggleDropdown={toggleDropdown}
              dropdownStates={dropdownStates}
              location={location}
            />
          ))}
        </ul>
        <div className="mt-2 px-2 py-2">
          <NavLink
            onClick={logout}
            to="/"
            className="flex w-full items-center space-x-2 font-semibold text-brand-text-light hover:text-red-700"
          >
            <IoIosLogOut className="text-xl" />
            <span>Logout</span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default SellerSidebar;
